/* Direct playback controls for homepage and supporting frame videos. */
(() => {
  'use strict';
  if (window.GrowplayVideoTap) return;
  const videos = new Map();
  function init(root) {
    root.querySelectorAll('.product-video-section video, .certified-safety-section video, .height-adjustable-section video, .built-to-last-section video').forEach(video => {
      if (videos.has(video)) return;
      const isFrame = document.documentElement.classList.contains('gp-frame-pdp');
      if (!isFrame && !video.closest('.product-video-section')) return;
      if (!video.autoplay && video.dataset.gpAutoplay !== 'true') return;
      if (video.controls) return;
      const state = {userPaused:false};
      const heading = video.closest('.shopify-section')?.querySelector('h1, h2, h3');
      if (!video.getAttribute('aria-label')) video.setAttribute('aria-label', heading?.textContent.trim() || 'Growplay video');
      video.dataset.gpTapVideo = 'true';
      video.setAttribute('role', 'button');
      video.tabIndex = 0;
      state.update = () => {
        // Preserve an explicit pause when older viewport observers try autoplay.
        if (state.userPaused && !video.paused) video.pause();
        video.setAttribute('aria-pressed', String(!video.paused));
      };
      state.toggle = () => {
        state.userPaused = !video.paused;
        const button = video.nextElementSibling;
        if (button?.classList.contains('gp-video-toggle')) {
          // Let the existing lazy player retain its own loading and pause state.
          button.click();
        } else if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      };
      state.keydown = event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        state.toggle();
      };
      video.addEventListener('click', state.toggle);
      video.addEventListener('keydown', state.keydown);
      ['play', 'pause', 'ended'].forEach(name => video.addEventListener(name, state.update));
      state.update();
      videos.set(video, state);
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => videos.forEach((state, video) => {
    if (!event.target.contains(video)) return;
    video.removeEventListener('click', state.toggle);
    video.removeEventListener('keydown', state.keydown);
    ['play', 'pause', 'ended'].forEach(name => video.removeEventListener(name, state.update));
    videos.delete(video);
  }));
  window.GrowplayVideoTap = {init};
  init(document);
})();
